import type { JSX } from 'react';

import { Image, Text } from '@change/ds-core-ui/next';

import { Translate, TranslatePluralHtml } from '@change-corgi/core/react/i18n';

import { useVictoryCount } from './hooks/useVictoryCount';

export function VictoriesBody(): JSX.Element {
	const {
		data: { totalVictoryCount, totalVictoryCountLocalized },
	} = useVictoryCount();
	return (
		<div className="pb-10">
			<div className="container">
				<div className="flex flex-col items-center justify-center gap-4 py-16">
					<Text as="h2" variant="heading" className="text-center">
						<Translate value="fe.pages.impact.victories.h" />
					</Text>
					<Text size="large" as="p" className="max-w-2xl text-center">
						<Translate value="fe.pages.impact.victories.p" />
					</Text>
				</div>
				<div className="flex items-center justify-center gap-4">
					<Image
						src="https://static.change.org/brand-pages/impact/impact-thank_you_stars_left.png"
						alt=""
						className="hidden h-24 w-24 md:block"
					/>
					<Text as="h2" variant="heading" className="text-center" size="x-large">
						<TranslatePluralHtml
							value="fe.pages.impact.victories.num_victories_v2_html"
							count={totalVictoryCount}
							replacements={{ num: totalVictoryCountLocalized }}
						/>
					</Text>
					<Image
						src="https://static.change.org/brand-pages/impact/impact-thank_you_stars_right.png"
						alt=""
						className="hidden h-24 w-24 md:block"
					/>
				</div>
			</div>
		</div>
	);
}
